<div class="card">
    <div class="header">
        <div class="vehicle-info">
            <div class="plate-row">
                <h3 class="plate">{{ displayId }}</h3>
                <span class="issued-date" *ngIf="displayIssuedAt">{{ displayIssuedAt }}</span>
            </div>
            <p class="model">
                {{ order.vehicle }}
                <ng-container *ngIf="order.year"> • {{ order.year }}</ng-container>
            </p>
        </div>
        <div class="status-badge" [ngClass]="getStatusClass(order.status)">
            {{ order.status }}
        </div>
    </div>

    <div class="divider"></div>

    <div class="details">
        <div class="client">
            <label>CLIENTE</label>
            <span>{{ order.client }}</span>
        </div>
        <div class="technician icon-text-row pill-bg">
            <span class="material-symbols-rounded icon">engineering</span>
            <span>{{ order.technician }}</span>
        </div>
    </div>
</div>
